"use strict";

export class TextToSpeech {
  constructor() {
    this.baseUrl = process.env.REACT_APP_TTS_ENDPOINT || 'http://localhost:8005';
    this.currentAudio = null;
    this.audioContext = null;
    this.gainNode = null;
    this.nextPlayTime = 0;
    this.startTime = 0;
    
    console.log('TTS initialized with URL:', this.baseUrl);
  }

  async initAudioContext() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)({
        latencyHint: 'interactive',
        sampleRate: 24000
      });
      this.gainNode = this.audioContext.createGain();
      this.gainNode.connect(this.audioContext.destination);
    }
    if (this.audioContext.state === 'suspended') {
      await this.audioContext.resume();
    }
  }

  async synthesize(text) {
    try {
      await this.initAudioContext();
      
      if (this.currentAudio) {
        this.stopCurrent();
      }

      this.startTime = performance.now();
      console.log('Starting TTS request at:', this.startTime);
      
      const response = await fetch(`${this.baseUrl}/v1/audio/speech/with_streaming_response/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'kokoro',
          input: text,
          voice: 'af_bella',
          response_format: 'pcm'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      this.nextPlayTime = 0;
      let isFirstChunk = true;
      let chunkCount = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunkCount++;
        const now = performance.now();
        console.log(`Chunk ${chunkCount} received after ${(now - this.startTime).toFixed(2)}ms`);

        // Immediately process and schedule the chunk
        const pcmData = new Int16Array(value.buffer);
        const floatData = new Float32Array(pcmData.length);
        for (let i = 0; i < pcmData.length; i++) {
          floatData[i] = pcmData[i] / 32768.0;
        }

        const audioBuffer = this.audioContext.createBuffer(1, floatData.length, 24000);
        audioBuffer.getChannelData(0).set(floatData);

        const source = this.audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(this.gainNode);

        // Schedule playback with minimal delay
        const playTime = Math.max(this.audioContext.currentTime, this.nextPlayTime);
        source.start(playTime);
        
        if (isFirstChunk) {
          console.log(`First chunk playing at ${(performance.now() - this.startTime).toFixed(2)}ms`);
          isFirstChunk = false;
        }

        // Update scheduling
        this.nextPlayTime = playTime + audioBuffer.duration;
        this.currentAudio = source;

        // Log timing for this chunk
        const processEnd = performance.now();
        console.log(`Chunk ${chunkCount} processed and scheduled in ${(processEnd - now).toFixed(2)}ms`);
      }

    } catch (error) {
      console.error('Error in TTS:', error);
      throw error;
    }
  }

  async speak(text) {
    return this.synthesize(text);
  }

  stopCurrent() {
    if (this.currentAudio) {
      try {
        this.currentAudio.stop();
        this.currentAudio.disconnect();
        this.currentAudio = null;
      } catch (e) {
        console.warn('Error stopping audio:', e);
      }
    }
    this.nextPlayTime = 0;
  }
}